import { ca } from '@cian/analytics';
import { IPage, IPageExtra } from '../../types/analytics';

export const trackRequestFormShowError = (page: IPage, extra: IPageExtra) => {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Fail_newbuilding_kpn_survey',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
    page: {
      ...page,
      extra: {
        ...extra,
      },
    },
  });
};
